import { ErrorHandler, NgModule, isDevMode } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { ServiceWorkerModule } from '@angular/service-worker'
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular'
import {
  OcChipComponent,
  OcModalComponent,
  OcToastComponent,
  OcToggleComponent,
} from 'otimus-library'
import { environment } from 'src/environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { DrawerComponent } from './components/drawer/drawer.component'
import { MarkerComponent } from './components/marker/marker.component'
import { EmptyContainerComponent } from './containers/empty-container/empty-container.component'
import { ResponsiveContainerComponent } from './containers/responsive-container/responsive-container.component'
import { SystemTokenInterceptor } from './interceptors/system-token.interceptor'
import { ServerUrlService } from './services/server-url.service'

@NgModule({
  declarations: [AppComponent, EmptyContainerComponent, ResponsiveContainerComponent],
  bootstrap: [AppComponent],
  imports: [
    ApmModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DrawerComponent,
    MarkerComponent,
    OcToastComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    OcModalComponent,
    OcToggleComponent,
    OcChipComponent,
  ],
  providers: [
    ApmService,
    ServerUrlService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SystemTokenInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {
  constructor(service: ApmService) {
    // Agent API is exposed through this apm instance
    const apm = service.init({
      serviceName: environment.ELASTIC_APM_SERVICE_NAME,
      serverUrl: environment.ELASTIC_APM_SERVER_URL,
      // secretToken: environment.ELASTIC_APM_SECRET_TOKEN,
      environment: environment.ELASTIC_APM_ENVIRONMENT,
    })

    apm.setUserContext(environment.ELASTIC_CONTEXT)
  }
}
